import { DocumentCategory, Lables, Nach, Other, ProofOfAddress, ProofOfId, Photo, kycFlow, kycFlowStatus, IPVMode } from '../enums/enum';

export class Document {
    documentId: string;
    documentLabel: Lables;
    documentCategory: DocumentCategory;
    fileName: string;
    fileExtension: string;
    fileContent: string;
    fileSize: number;
    isAdditionalDocument: boolean;
    status: any;
    label: string;
    isClicked: boolean;
    documentRelationId: string;
    thumbnail: string;
    side: string;
    ext: string;
    createdOn: number;
}
export class DocumentLabel {
    ProofOfId: ProofOfId;
    ProofOfAddress: ProofOfAddress;
    Photo: Photo;
    Nach: Nach;
    Other: Other;
}

export class KycPageResponse {
    active: boolean;
    errorCode: string;
    errorDescription: string;
}

export class FetchKYCParams {
    hash: string;
    requestId: string;
    status: string;
    uuid: string;
}

export class PatchKycFlowUI {
    kycFlow: kycFlow;
    kycFlowStatus: kycFlowStatus;
    kycFlowCompleted: boolean;
    ipvMode?: IPVMode;
}

export class KhoslaResponseParam {
    requestId: string;
    uuid: string;
    hash: string;
    status: string;
}

export class SubmitPageContent {
    submitHeader: string;
    submitPageSubHeader: string;
    logoSrc: string;
}

export class KycFeaturePage {
    kyc: boolean;
    okycOnly: boolean;
    version: string;
    constructor(k: boolean, o: boolean, v: string) {
        this.kyc = k;
        this.okycOnly = o;
        this.version = v;
    }
}
